export const browserTest = {
    showWarningModal: true,
};
